import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=06cf3f06&scoped=true"
import script from "./WysiwygEditor.vue?vue&type=script&lang=js"
export * from "./WysiwygEditor.vue?vue&type=script&lang=js"
import style0 from "./WysiwygEditor.vue?vue&type=style&index=0&id=06cf3f06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf3f06",
  null
  
)

export default component.exports